import { render, staticRenderFns } from "./DoTest.vue?vue&type=template&id=6079bad0&scoped=true"
import script from "./DoTest.vue?vue&type=script&lang=js"
export * from "./DoTest.vue?vue&type=script&lang=js"
import style0 from "./DoTest.vue?vue&type=style&index=0&id=6079bad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6079bad0",
  null
  
)

export default component.exports